// Shared attendance constants/helpers — extracted out of firebaseService.js
// so attendanceServiceV2.js can import them without forming an import cycle
// (firebaseService.js -> attendanceServiceV2.js -> firebaseService.js).
// react-refresh's `registerExportsForReactRefresh` trips a TDZ when re-export
// bindings are read mid-cycle in dev mode.

export const ATTENDANCE_STATUSES = {
  PRESENT: 'present',
  LATE: 'late',
  ABSENT: 'absent',
  EXCUSED: 'excused'
};

export const summarizeAttendance = (rows = []) => {
  const summary = {
    total: rows.length,
    present: 0,
    late: 0,
    absent: 0,
    excused: 0
  };
  for (const row of rows) {
    if (summary[row?.status] !== undefined) summary[row.status] += 1;
  }
  summary.attendanceRate =
    summary.total > 0
      ? Math.round(((summary.present + summary.late) / summary.total) * 100)
      : null;
  return summary;
};
